"use client"

import { Alert } from "./alert"
import { Button } from "./button"
import { CopyButton } from "./copy-button"
import { Input } from "./form/input"

interface SecretRevealProps {
	value: string
	description: string
	onCopied?: () => void
	onClose: () => void
	closeLabel?: string
}

export function SecretReveal({
	value,
	description,
	onCopied,
	onClose,
	closeLabel = "Copy and close",
}: SecretRevealProps) {
	const copy = async () => {
		await navigator.clipboard.writeText(value)
		onCopied?.()
	}

	return (
		<div className="space-y-4">
			<p className="text-sm text-secondary">{description}</p>
			<Alert variant="info">
				{"You won't be able to access it again. Copy it now."}
			</Alert>
			<Input
				name="secret-reveal"
				readOnly
				value={value}
				inputClassName="font-mono"
				truncate
				suffix={<CopyButton value={value} onCopied={onCopied} />}
				onFocus={(e) => e.currentTarget.select()}
			/>
			<div className="flex justify-end">
				<Button
					onClick={async () => {
						await copy()
						onClose()
					}}
				>
					{closeLabel}
				</Button>
			</div>
		</div>
	)
}
